/*
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-29 13:49:26
 * @LastEditTime: 2021-10-09 10:16:35
 */
export const checkPhone = (rule, value, callback) => {
  let phoneReg = /^1\d{10}$/;
  if (!value) {
    callback(new Error('请填写手机号'));
  } else if (!phoneReg.test(value)) {
    callback(new Error('请填写正确手机号'));
  } else {
    callback();
  }
};
export const checkNumber = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('不能为空'));
  } else if (isNaN(value)) {
    callback(new Error('请填写数字'));
  } else if (value < 0) {
    callback(new Error('不能小于0'));
  } else {
    callback();
  }
};

export const checkAddress = function(rule, value, callback) {
  if (
    !this.ruleForm.provinceId ||
    !this.ruleForm.cityId ||
    !this.ruleForm.areaId ||
    !this.ruleForm.address
  ) {
    callback(new Error('请输入地址'));
  } else {
    callback();
  }
};
export const checkLongitude = (rule, value, callback) => {
  if (!this.ruleForm.longitude || !this.ruleForm.latitude) {
    callback(new Error('请输入经纬度'));
  } else {
    callback();
  }
};

export const priceFilter = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('不能为空'));
  } else if (isNaN(value)) {
    callback(new Error('请填写数字'));
  } else if (value > 10000000000000) {
    callback(new Error('请输入有效的金额'));
  } else if (value <= 0) {
    callback(new Error('必须为正数'));
  } else {
    callback();
  }
};

export const priceFilterForTools = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('不能为空'));
  } else if (isNaN(value)) {
    callback(new Error('请填写数字'));
  } else if (value > 10000000000000) {
    callback(new Error('请输入有效的金额'));
  } else if (value < 0) {
    callback(new Error('必须为正数'));
  } else {
    callback();
  }
};
export const isInteger = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('不能为空'));
  } else if (!Number.isInteger(Number(value))) {
    callback(new Error('请填写整数'));
  } else if (value <= 0) {
    callback(new Error('必须为正数'));
  } else {
    callback();
  }
};
export const checkTax = (rule, value, callback) => {
  let num = Number(value);
  console.log(num);
  if (value === '' || value === null || value === undefined) {
    callback(new Error('不能为空'));
  } else if (Number.isNaN(num)) {
    callback(new Error('请输入数字'));
  } else if (num < 0) {
    callback(new Error('税率应该大于等于0'));
  } else if (num > 100) {
    callback(new Error('税率不能大于100'));
  } else {
    callback();
  }
};
// 身份证识别号 可能是 11 可能是 18
export const identifyNum = (rule, value, callback) => {
  let phoneReg = /^(((1[3456789][0-9]{1})|(15[0-9]{1}))+\d{8})$/;
  let isCardId = sId => {
    var aCity = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    };
    var iSum = 0;
    var info = '';
    if (!/^\d{17}(\d|x)$/i.test(sId)) return '你输入的身份证长度或格式错误';
    sId = sId.replace(/x$/i, 'a');
    if (aCity[parseInt(sId.substr(0, 2))] == null) return '你的身份证地区非法';
    let sBirthday =
      sId.substr(6, 4) +
      '-' +
      Number(sId.substr(10, 2)) +
      '-' +
      Number(sId.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, '/'));
    if (
      sBirthday !=
      d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    )
      return '身份证上的出生日期非法';
    for (var i = 17; i >= 0; i--)
      iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    if (iSum % 11 != 1) return '你输入的身份证号非法';
    //aCity[parseInt(sId.substr(0,2))]+","+sBirthday+","+(sId.substr(16,1)%2?"男":"女");//此次还可以判断出输入的身份证号的人性别
    return true;
  };
  if (!value) {
    callback(new Error('不能为空'));
  } else if (value.length == 11) {
    if (!phoneReg.test(value)) {
      callback(new Error('手机号输入有误'));
    } else {
      callback();
    }
  } else if (value.length == 18) {
    if (isCardId(value) !== true) {
      callback(new Error('身份证号填写有误'));
    } else {
      callback();
    }
  } else {
    callback(new Error('填写错误'));
  }
};

// 检验图片是否已上传
export const checkUpLoadImg = (rule, value, callback) => {
  if (!value || !value.length) {
    callback(new Error('至少上传一张图片'));
  } else {
    callback();
  }
};

// 库存
export const checkStockCount = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('不能为空'));
  } else if (isNaN(value) || value < 0 || /\./.test(value)) {
    callback(new Error('请填写正确数字'));
  } else if (value > 100000) {
    callback(new Error('库存不能超过100000'));
  } else {
    callback();
  }
};
